<template>
    <b-dropdown text="Create Template" split variant="primary" :disabled="disabled" @click="createTemplate()">
        <b-dropdown-item
            data-dd-action-name="Create Template - From Customily Designs gallery"
            @click="importTemplateFromCustomilyDesign()"
        >
            <div>
                <span v-text="'From Customily Designs gallery'" />
                <img class="start" :src="sparkles" />
            </div>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script setup lang="ts">
import sparkles from '../../assets/images/sparkle.svg';
defineProps<{
    disabled?: boolean;
}>();
const emit = defineEmits(['createTemplate', 'importTemplateFromCustomilyDesign']);

const createTemplate = function () {
    emit('createTemplate');
};

const importTemplateFromCustomilyDesign = function () {
    emit('importTemplateFromCustomilyDesign');
};
</script>
